import React from "react";
import Hero from "../../components/site/Hero";
import SlidingText from "./SlidingText";
import ComingSoonTeaser from "../../components/site/ComingSoonTeaser";
import HomeGalleryPreview from "../../components/site/HomeGalleryPreview";
import SponsorsStrip from "../../components/site/SponsorsStrip";

const HomeMain = () => {
  return (
    <>
      <Hero />
      <SlidingText />
      <ComingSoonTeaser />
      <HomeGalleryPreview />
      <SponsorsStrip />
    </>
  );
};

export default HomeMain;